/*
 * This program is part of the OpenCms Rebrush Template.
 *
 * Copyright (c) Alkacon Software GmbH & Co. KG (http://www.alkacon.com)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// Module implemented using the "revealing module pattern", see
// https://addyosmani.com/resources/essentialjsdesignpatterns/book/#revealingmodulepatternjavascript
// https://www.christianheilmann.com/2007/08/22/again-with-the-module-pattern-reveal-something-to-the-world/
var RebrushSliders = function(jQ) {

    "use strict";

    // global slider variables
    var m_revSliderVars;

    function initRevSliderVars() {

        if (typeof m_revSliderVars === "undefined") {
            m_revSliderVars = {};

            var responsiveLevels = {};
            responsiveLevels.xl = 1200;
            responsiveLevels.lg = 1199;
            responsiveLevels.md = 991;
            responsiveLevels.sm = 767;
            responsiveLevels.xs = 575;
            m_revSliderVars.responsiveLevels = responsiveLevels;

            var gridwidth = {};
            gridwidth.xl = 1140;
            gridwidth.lg = 940;
            gridwidth.md = 720;
            gridwidth.sm = 720;
            gridwidth.xs = 540;
            m_revSliderVars.gridwidth = gridwidth;
        }
    }

    /**
     * Calculates the grid height values for the different screen sizes
     *
     * @param slHeight the desired slider ratio or height value
     * @param slHeightSM the desired slider ratio or height value for small screen sizes
     * @returns an object with attributes "obj.xl", "obj.lg", "obj.md", "obj.sm", "obj.xs"
     */
    function calcGridHeights(slHeight, slHeightSM) {
        var slRatio = Rebrush.calcRatio(slHeight);
        var slRatioSM = Rebrush.calcRatio(slHeightSM);
        var result = {};
        if (slRatio.valid) {
            // ratio is given, calculate heights
            var factor = 0;
            if (slHeightSM == "") {
                // no value for small screens available, use common ratio
                result.xs = m_revSliderVars.gridwidth.xs / (slRatio.ratio);
            } else {
                if (slRatioSM.valid) {
                    // ratio for small screens is given, calculate factor for sizes between, and small height
                    var diff = slRatio.ratio - slRatioSM.ratio;
                    factor = diff / 4;
                    result.xs = m_revSliderVars.gridwidth.xs / (slRatioSM.ratio);
                } else {
                    // height is given
                    result.xs = slHeightSM;
                }
            }
            result.xl = m_revSliderVars.gridwidth.xl / slRatio.ratio;
            result.lg = m_revSliderVars.gridwidth.lg / (slRatio.ratio - factor);
            result.md = m_revSliderVars.gridwidth.md / (slRatio.ratio - (factor * 2));
            result.sm = m_revSliderVars.gridwidth.sm / (slRatio.ratio - (factor * 3));
        } else {
            // absolute height is given, apply to all screen sizes
            result.xl = slHeight;
            result.lg = slHeight;
            result.md = slHeight;
            result.sm = slHeight;
            if (slHeightSM == "") {
                // no value for small screens available, use common height
                result.xs = slHeight;
            } else {
                if (slRatioSM.valid) {
                    // ratio for small screens is given
                    result.xs = m_revSliderVars.gridwidth.xs / (slRatioSM.ratio);
                } else {
                    // height is given
                    result.xs = slHeightSM;
                }
            }
        }
        return result;
    }

    /**
     * Simple sliders
     */
    function initSimpleRevSliders($sliders) {

        initRevSliderVars();
        $sliders.each(function(){

            var $slider = jQ(this);
            var sliderId = $slider.data("sid");

            var extPath = $slider.data("ext");
            if (DEBUG) console.log("Revslider ExtPath: " + extPath);


            // determine scroll bar width because RS does not consider this when using responsive levels
            var w1 = window.innerWidth;
            var w2 = jQ('body').innerWidth();
            var scrollWidth = w1 - w2;

            // calculate grid heights for the slider depending on the entered ratio / height
            var slHeight = $slider.data("height");
            var slHeightSM = $slider.data("heightsm");
            var slGridHeights = calcGridHeights(slHeight, slHeightSM);
            if (DEBUG){
                console.log("Revslider calculated heights:\nXL: " + slGridHeights.xl
                        + "\nLG: "+ slGridHeights.lg
                        + "\nMD: "+ slGridHeights.md
                        + "\nSM: "+ slGridHeights.sm
                        + "\nXS: "+ slGridHeights.xs);
            }

            if (!$slider.data("init")) {
                var slideCount = $slider.data("slidecount");
                if (DEBUG) console.log("Revslider slide count=" + slideCount);

                var slConfig = {
                    sliderLayout: 'auto',
                    autoHeight: 'on',
                    extensions: extPath,
                    responsiveLevels: [
                        m_revSliderVars.responsiveLevels.xl - scrollWidth,
                        m_revSliderVars.responsiveLevels.lg - scrollWidth,
                        m_revSliderVars.responsiveLevels.md - scrollWidth,
                        m_revSliderVars.responsiveLevels.sm - scrollWidth,
                        m_revSliderVars.responsiveLevels.xs - scrollWidth
                    ],
                    gridwidth: [
                        m_revSliderVars.gridwidth.xl,
                        m_revSliderVars.gridwidth.lg,
                        m_revSliderVars.gridwidth.md,
                        m_revSliderVars.gridwidth.sm,
                        m_revSliderVars.gridwidth.xs
                    ],
                    gridheight: [
                        slGridHeights.xl,
                        slGridHeights.lg,
                        slGridHeights.md,
                        slGridHeights.sm,
                        slGridHeights.xs
                    ]
                };
                if (slideCount > 1) {
                    if (DEBUG) console.log("Revslider has more than one slide, using complete settings");
                    slConfig.sliderType = "standard";
                    slConfig.delay = $slider.data("delay");
                    slConfig.spinner = "spinner0";
                    slConfig.lazyType = "smart";
                    slConfig.disableProgressBar = $slider.data("noprogressbar");
                    slConfig.stopLoop = "off";
                    slConfig.stopAtSlide = -1;
                    slConfig.stopAfterLoops = -1;
                    slConfig.viewPort = {
                        enable: true,
                        outof: 'wait',
                        visible_area: '80%',
                        presize: true
                    }
                    slConfig.navigation = {
                          keyboardNavigation:"off",
                          onHoverStop: $slider.data("onhoverstop"),
                          touch:{
                                 // must be turned off because on iOS you cannot scroll over the slider otherwise
                                 touchenabled:"off",
                                 // swipe_treshold : 75,
                                 // swipe_min_touches : 1,
                                 // drag_block_vertical:true,
                                 // swipe_direction:"horizontal"
                          },
                          arrows: {
                             style:"hesperiden",
                             enable: $slider.data("arrows"),
                             rtl:false,
                             hide_onmobile:false,
                             hide_onleave:true,
                             hide_delay:200,
                             hide_delay_mobile:1200,
                             hide_under:0,
                             hide_over:9999,
                             tmp:'',
                             left : {
                                    container:"slider",
                                    h_align:"left",
                                    v_align:"center",
                                    h_offset:20,
                                    v_offset:0,
                             },
                             right : {
                                    container:"slider",
                                    h_align:"right",
                                    v_align:"center",
                                    h_offset:20,
                                    v_offset:0
                             }
                          },
                          bullets: {
                             style:"hesperiden",
                             enable:$slider.data("navbutton"),
                             hide_onmobile:false,
                             hide_onleave:true,
                             hide_delay:200,
                             hide_delay_mobile:1200,
                             hide_under:0,
                             hide_over:9999,
                             direction:"horizontal",
                             h_align:"center",
                             v_align:$slider.data("navtype"),
                             space:5,
                             h_offset:0,
                             v_offset:20,
                             tmp:'<span class="tp-bullet-title"></span>'
                         }
                    };
                } else {
                    if (DEBUG) console.log("Revslider has just one slide, using reduced settings");
                    slConfig.sliderType = "hero";
                    slConfig.delay = -1;
                    slConfig.lazyType = "none";
                    slConfig.disableProgressBar = true;
                    slConfig.stopLoop = "on";
                    slConfig.stopAtSlide = 0;
                    slConfig.stopAfterLoops = 1;
                };

                jQ('#ap-slider-' + sliderId).show().revolution(slConfig);

            }
            $slider.data("init", "true");

        });
    }

    /**
     * Complex sliders
     */
    function initComplexRevSliders($sliders) {

        initRevSliderVars();
        $sliders.each(function(){

            var $slider = jQ(this);
            var sliderId = $slider.data("sid");

            var extPath = $slider.data("ext");
            if(DEBUG){
                console.log("Revslider ExtPath: " + extPath);
            }

            // determine scroll bar width because RS does not consider this when using responsive levels
            var w1 = window.innerWidth;
            var w2 = jQ('body').innerWidth();
            var scrollWidth = w1 - w2;

            // calculate grid heights for the slider depending on the entered ratio / height
            var slHeight = $slider.data("height");
            var slHeightSM = $slider.data("heightsm");
            var slGridHeights = calcGridHeights(slHeight, slHeightSM);
            if(DEBUG){
                console.log("Revslider calculated heights:\nXL: " + slGridHeights.xl
                    + "\nLG: "+ slGridHeights.lg
                    + "\nMD: "+ slGridHeights.md
                    + "\nSM: "+ slGridHeights.sm
                    + "\nXS: "+ slGridHeights.xs);
            }

            if (!$slider.data("init")) {
                var slConfig = {
                    delay: $slider.data("delay"),
                    disableProgressBar: $slider.data("noprogressbar"),
                    sliderType: 'standard',
                    sliderLayout: 'auto',
                    autoHeight: 'on',
                    spinner: 'spinner0',
                    lazyType: "smart",
                    stopAtSlide: -1,
                    stopAfterLoops: -1,
                    gridwidth : [
                        m_revSliderVars.gridwidth.xl,
                        m_revSliderVars.gridwidth.lg,
                        m_revSliderVars.gridwidth.md,
                        m_revSliderVars.gridwidth.sm,
                        m_revSliderVars.gridwidth.xs
                    ],
                    gridheight : [
                        slGridHeights.xl,
                        slGridHeights.lg,
                        slGridHeights.md,
                        slGridHeights.sm,
                        slGridHeights.xs
                    ],
                    navigation : {
                          keyboardNavigation:"off",
                          onHoverStop: $slider.data("onhoverstop"),
                          touch:{
                                 touchenabled:"on",
                                 swipe_treshold : 75,
                                 swipe_min_touches : 1,
                                 drag_block_vertical:true,
                                 swipe_direction:"horizontal"
                          },
                          arrows: {
                             style:"hesperiden",
                             enable: $slider.data("arrows"),
                             rtl:false,
                             hide_onmobile:false,
                             hide_onleave:true,
                             hide_delay:200,
                             hide_delay_mobile:1200,
                             hide_under:0,
                             hide_over:9999,
                             tmp:'',
                             left : {
                                    container:"slider",
                                    h_align:"left",
                                    v_align:"center",
                                    h_offset:20,
                                    v_offset:0,
                             },
                             right : {
                                    container:"slider",
                                    h_align:"right",
                                    v_align:"center",
                                    h_offset:20,
                                    v_offset:0
                             }
                          },
                          bullets: {
                             enable: $slider.data("navbutton"),
                             style: 'hesperiden',
                             tmp:'<span class="tp-bullet-title"></span>',
                             hide_onmobile:false,
                             hide_onleave:true,
                             hide_delay:200,
                             hide_delay_mobile:1200,
                             hide_under:0,
                             hide_over:9999,
                             direction:"horizontal",
                             h_align:"center",
                             v_align:$slider.data("navtype"),
                             h_offset:20,
                             v_offset:20,
                             space: 5
                         }
                    },

                    extensions: extPath
                };

                if ($slider.data("responsive")) {
                    slConfig.responsiveLevels = [
                        m_revSliderVars.responsiveLevels.xl - scrollWidth,
                        m_revSliderVars.responsiveLevels.lg - scrollWidth,
                        m_revSliderVars.responsiveLevels.md - scrollWidth,
                        m_revSliderVars.responsiveLevels.sm - scrollWidth,
                        m_revSliderVars.responsiveLevels.xs - scrollWidth
                    ];

                    slConfig.visibilityLevels = [
                        m_revSliderVars.gridwidth.xl,
                        m_revSliderVars.gridwidth.lg,
                        m_revSliderVars.gridwidth.md,
                        m_revSliderVars.gridwidth.sm,
                        m_revSliderVars.gridwidth.xs
                    ];
                }

                jQ('#ap-slider-' + sliderId).show().revolution(
                    slConfig
                );

            }
            $slider.data("init", "true");

        });
    }

    /**
     * Slick sliders
     */
    function initSlickSliders($sliders) {

        $sliders.each(function(){
            var $slider = jQ(this);
            var $sliderElement = $slider.find('.ap-slick-slides.list-of-slides');
            var data = $sliderElement.data('apslick') || {};
            if (Rebrush.device().mobile()) {
                data.arrows = false;
                data.fade = false;
            }
            $sliderElement.slick(data);
        });
    }

    function init() {

        if (DEBUG) console.info("RebrushSliders.init()");

        if (Rebrush.plugin().slickSlider) {
            var $slickSliders = jQuery('.ap-slick-slider');
            if (DEBUG) console.info(".ap-slick-slider elements found: " + $slickSliders.length);
            if ($slickSliders.length > 0) {
                initSlickSliders($slickSliders);
            }
        }

        if (Rebrush.plugin().revolutionSlider) {
            var $simpleSliders = jQuery('.ap-slider');
            if (DEBUG) console.info(".ap-slider elements found: " + $simpleSliders.length);
            if ($simpleSliders.length > 0) {
                initSimpleRevSliders($simpleSliders);
            }

            var $complexSliders = jQuery('.ap-complex-slider');
            if (DEBUG) console.info(".ap-complex-slider elements found: " + $complexSliders.length);
            if ($complexSliders.length > 0) {
                initComplexRevSliders($complexSliders);
            }
        }
    }

    // public available functions
    return {
        init: init
    }

}(jQuery);
